import axios from 'axios'
import {
  isEmpty
} from '@/js/util'
import util from '../../util/util'

let instance = axios.create({
  baseURL: process.env.VUE_APP_CLIENT_SERVER_URL
})
// axios.defaults.withCredentials=true;
function request (options) {
  options = setToken(options)
  return new Promise((resolve, reject) => {
    instance(options)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

function setToken (options) {
  let userInfo = util.getToken()
  let baseHeader = {}

  if (userInfo && !isEmpty(userInfo.accessToken)) {
    baseHeader = {
      'X-Token': userInfo.accessToken
    }
    options['headers'] = baseHeader
  }
  return options
}
function getLanguage () {
  let locale = util.getProfile().locale || 'cn'
  switch (locale) {
    case 'zh-hant':
      return 'hk'
    case 'zh-hans':
      return 'cn'
    default:
      return 'cn'
  }
}

function getParamsUrl (options) {
  let result = '?'
  for (let key in options) {
    if (options[key] || options[key] === 0) {
      result += (key + '=' + options[key] + '&')
    } else {
      result += (key + '=&')
    }
  }
  if (result[result.length - 1] === '&') {
    result = result.substring(0, result.length - 1)
  }
  return result
}

export function reqTradeAccountList (accountNumber) {
  return request({
    method: 'get', // 请求方式
    url: `/accountInfos?accountNumber=${accountNumber}`
  })
}

export function reqCreateAccountRecords (options) {
  return request({
    method: 'post',
    url: 'public/tradeAccounts',
    data: options || {}
  })
}

export function reqApplyTradeRecords (options) {
  return request({
    method: 'get',
    url: 'public/tradeAccounts' + getParamsUrl(options),
    data: options || {}
  })
}

export function reqRejectRecords (option) {
  return request({
    method: 'get',
    url: 'public/tradeAccounts/getRejectRecords' + getParamsUrl(option),
    data: option || {}
  })
}

export function reqImgUrl (imgKey) {
  return request({
    method: 'get',
    url: `/image/${imgKey}?key=public/${imgKey}`,
    data: imgKey || {}
  })
}

export function reqSysconfig (option) {
  return request({
    method: 'get',
    url: 'public/sysConfig/setBullion' + getParamsUrl(option),
    data: option || {}
  })
}

export function reqAccountBalance (options) {
  return request({
    method: 'get',
    url: 'public/accountBalance',
    params: options || {}
  })
}
